<template>
  <div class="page-container">
    <div class="account-card">
      <span class="page-title">個人帳號</span>
      <div class="card-content">
        <div class="header">
          <div class="user-info">
            <h3>{{ user.last_name + user.first_name }}</h3>
            <p>{{ user.email }}</p>
          </div>
          <div class="buttons">
            <button @click="onLogout">登出</button>
            <button @click="onEdit">編輯</button>
          </div>
        </div>
        <hr/>
        <div class="details">
          <div class="detail-row">
            <div>權限：<span>{{ $t(`roles.${user.role}`) }}</span></div>
            <div>公司：<span>{{ user.organization?.name || "無" }}</span></div>
          </div>
          <div class="detail-row">
            <div>狀態：<span>{{ user.is_active ? "正常" : "停權" }}</span></div>
            <div>註冊日期：<span>{{ formatDate(new Date(user.date_joined)) }}</span></div>
          </div>
          <div class="detail-row">
            <div>最後登入：<span>{{ formatDate(new Date(user.last_login)) }}</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccountCard',
  inject: ['getUserData', 'clearUserData'],
  data() {
    return {};
  },
  mounted() {

    const token = localStorage.getItem('token');
    this.$axios.get('/api/users/profile', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then(response => {
      this.profile = response.data.data;
      console.log(response.data.data);
    }).catch(error => {
      console.error(error);
    });
  },
  computed: {
    user() {
      return this.getUserData();
    },
  },
  methods: {
    onLogout() {
      alert("Logged out!");
      this.clearUserData();
      this.$router.push('/login');
    },
    onEdit() {
      this.$router.push('/profile/edit');
    },
    formatDate(date) {
      return new Intl.DateTimeFormat("en-CA", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(date);
    },
  }
};
</script>

<style scoped>
.card-content {
  background-color: white;
  border-radius: 8px;
  margin-top: 16px;
  max-width: 800px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 28px 32px;
}

hr {
  border: 1px solid #e0e0e0;
}

.user-info h3 {
  font-size: 24px;
  margin: 0;
}

.user-info p {
  color: gray;
  margin: 0;
}

.buttons button {
  border: 1px solid #0000ff;
  background: none;
  color: #0000ff;
  padding: 5px 10px;
  border-radius: 5px;
  margin-left: 10px;
  cursor: pointer;
}

.details {
  padding: 28px 32px;
}

.details {
  display: grid;
  grid-template-columns: repeat(2, auto);
  gap: 8px 16px;
}

.detail-row {
  display: contents;
}

.detail-row div {
  text-align: left;
  color: #999999;
  size: 18px;
}

.detail-row div span {
  color: #333333;
}
</style>
